import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _createClass from "@babel/runtime/helpers/createClass";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _wrapNativeSuper from "@babel/runtime/helpers/wrapNativeSuper";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import _regeneratorRuntime from "@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/**
 * A custom `fetch` implementation that uses `node-fetch` as a base.
 * It adopts several features and conventions from
 * [ky](https://github.com/sindresorhus/ky) and the custom Savage X client, with
 * additional enhancements.
 *
 * This module is written in a higher-order function style, similar to Higher
 * Order Components (HOCs). Individual features are added with separate
 * functions, and the final `fetch` function is the result of composing them.
 * This is merely to make the code more testable and break it into bite-size
 * pieces: instead of one giant function, the additional features can be
 * debugged and modified individually.
 *
 * Features include:
 *
 * - Timeouts.
 * - Debug logging.
 * - Retries with configurable, exponential backoff using
 *   [node-retry](https://github.com/tim-kos/node-retry).
 * - Promise rejections on HTTP errors.
 * - Convenience options like `prefixUrl`, `searchParams`, and `json`.
 * - Hooks for performing additional logic or modification before the request is
 *   sent or the response is returned.
 */
import config from 'config';
import './nodeFetchPolyfill';
import generateId from 'nanoid/non-secure/generate';
import retry from 'retry';
import logger from './logger';
import { toPlainObject, getRetryConfig, getBaseURI } from './utils';
var debug = logger.extend('fetch');
var endsWithSlash = /\/$/;
var jsonContentType = /^application\/json($|;|\+)/;
export var HTTPError = /*#__PURE__*/function (_Error) {
  _inherits(HTTPError, _Error);

  var _super = _createSuper(HTTPError);

  function HTTPError(response) {
    var _this;

    _classCallCheck(this, HTTPError);

    _this = _super.call(this, "".concat(response.status, " ").concat(response.statusText).trim());
    _this.name = 'HTTPError';
    _this.response = response;
    return _this;
  }

  return _createClass(HTTPError);
}( /*#__PURE__*/_wrapNativeSuper(Error));
export var TimeoutError = /*#__PURE__*/function (_Error2) {
  _inherits(TimeoutError, _Error2);

  var _super2 = _createSuper(TimeoutError);

  function TimeoutError() {
    var _this2;

    var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'Request timed out';

    _classCallCheck(this, TimeoutError);

    _this2 = _super2.call(this, message);
    _this2.name = 'TimeoutError';
    return _this2;
  }

  return _createClass(TimeoutError);
}( /*#__PURE__*/_wrapNativeSuper(Error));

function rejectWithTimeout(timeout) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$log = _ref.log,
      log = _ref$log === void 0 ? debug : _ref$log;

  var timeoutId;
  var promise = new Promise(function (resolve, reject) {
    timeoutId = setTimeout(function () {
      log('Fetch timeout after %sms.', timeout);
      reject(new TimeoutError());
    }, timeout);
  }); // Give access to the `timeoutId` so it can be cleared if necessary.

  promise.timeoutId = timeoutId;
  return promise;
}

function resolveAfterTimeout(timeout) {
  var timeoutId;
  var promise = new Promise(function (resolve, reject) {
    timeoutId = setTimeout(resolve, timeout);
  }); // Give access to the `timeoutId` so it can be cleared if necessary.

  promise.timeoutId = timeoutId;
  return promise;
}
/**
 * Create a version of `fetch` that rejects with a `TimeoutError` after the
 * number of milliseconds given in `timeout` has elapsed. Pass `false` to
 * disable.
 */


export function withTimeout(baseFetch) {
  var defaults = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _defaults$timeout = defaults.timeout,
      defaultTimeout = _defaults$timeout === void 0 ? 30000 : _defaults$timeout;
  return function fetch(input) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _options$timeout = options.timeout,
        timeout = _options$timeout === void 0 ? defaultTimeout : _options$timeout;
    var promise = baseFetch(input, options);

    if (timeout === false) {
      return promise;
    }

    var timeoutError = rejectWithTimeout(timeout, options);
    var timeoutId = timeoutError.timeoutId;

    var onResolve = function onResolve(response) {
      clearTimeout(timeoutId);
      return response;
    };

    var onReject = function onReject(err) {
      clearTimeout(timeoutId);
      throw err;
    };

    var requestComplete = promise.then(onResolve, onReject);
    return Promise.race([timeoutError, requestComplete]);
  };
}
/**
 * Create a version of `fetch` that rejects with an `HTTPError` if `response.ok`
 * is false. The error object will have a `response` property. Pass the
 * `throwHttpErrors` option with a value of `false` to disable.
 */

export function withHttpErrors(baseFetch) {
  return function fetch(input) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _options$throwHttpErr = options.throwHttpErrors,
        throwHttpErrors = _options$throwHttpErr === void 0 ? true : _options$throwHttpErr;
    var promise = baseFetch(input, options);

    if (!throwHttpErrors) {
      return promise;
    }

    return promise.then(function (response) {
      if (!response.ok) {
        throw new HTTPError(response);
      }

      return response;
    });
  };
}
export var defaultRetryMethods = new Set(['GET', 'PUT', 'HEAD', 'DELETE', 'OPTIONS', 'TRACE']);
export var defaultRetryStatusCodes = new Set([408, 413, 429, 500, 502, 503, 504]);
/**
 * Return true if the given `error` could reasonably be the result of a bad
 * `fetch` (including via our custom `fetch`), or if it looks more like a
 * programmer error (via one of the standard JavaScript error types, like
 * `TypeError`). It's easier to do it this way rather than include a whitelist
 * of errors because some parts of `node-fetch` throw plain `Error` instances
 * instead of a custom type.
 */

export function isFetchError(error) {
  return !/^(Range|Reference|Syntax|Type|URI)Error$/.test(error.name);
}
export function defaultRetryPolicy(err, response, input, options) {
  if (!defaultRetryMethods.has(options.method)) {
    return false;
  }

  if (err) {
    if (isFetchError(err)) {
      return 'default';
    }
  } else if (defaultRetryStatusCodes.has(response.status)) {
    return 'default';
  }

  return false;
}
/**
 * Simulate request failures.
 */

export function withFailureSimulation(baseFetch) {
  var defaults = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return function fetch(input) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _options$failureRate = options.failureRate,
        failureRate = _options$failureRate === void 0 ? defaults.failureRate : _options$failureRate,
        _options$failureType = options.failureType,
        failureType = _options$failureType === void 0 ? defaults.failureType : _options$failureType,
        _options$log = options.log,
        log = _options$log === void 0 ? debug : _options$log;

    if (failureRate) {
      if (Math.random() < failureRate) {
        log("Simulating failure of type \u201C".concat(failureType, "\u201D, check Admin Tools to change this."));

        switch (failureType) {
          case 'fetch':
            throw new TypeError('Failed to fetch');

          case 'timeout':
            return new Promise(function () {// Never resolve!
            });

          default:
            {
              var _Response = global.Response;

              if (_Response) {
                return Promise.resolve(new _Response('{}', {
                  status: failureType
                }));
              } else {
                log('Response type not found; failure simulation will be skipped.');
              }
            }
        }
      }
    }

    return baseFetch(input, options);
  };
}
/**
 * Create a version of `fetch` with retry support. The `retry` option will be
 * passed to [getRetryConfig](./utils.js) along with the rejection error (if
 * any), response (if any), and fetch arguments.
 */

export function withRetry(baseFetch) {
  var defaults = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _defaults$retry = defaults.retry,
      defaultRetry = _defaults$retry === void 0 ? defaultRetryPolicy : _defaults$retry;
  return function fetch(input) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _options$retry = options.retry,
        retryOption = _options$retry === void 0 ? defaultRetry : _options$retry,
        _options$onRetry = options.onRetry,
        onRetry = _options$onRetry === void 0 ? defaults.onRetry : _options$onRetry,
        _options$registerTime = options.registerTimeout,
        registerTimeout = _options$registerTime === void 0 ? defaults.registerTimeout : _options$registerTime,
        _options$unregisterTi = options.unregisterTimeout,
        unregisterTimeout = _options$unregisterTi === void 0 ? defaults.unregisterTimeout : _options$unregisterTi,
        _options$log2 = options.log,
        log = _options$log2 === void 0 ? debug : _options$log2;

    var attemptFetch = function attemptFetch(attemptNumber) {
      return baseFetch(input, options).then(function (response) {
        return considerRetry(attemptNumber, null, response);
      }, function (err) {
        return considerRetry(attemptNumber, err, null);
      });
    };

    var considerRetry = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(attemptNumber, err, response) {
        var retryConfig, timeouts, timeout;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return getRetryConfig(retryOption, err, response, input, options);

              case 2:
                retryConfig = _context.sent;

                if (!retryConfig) {
                  _context.next = 11;
                  break;
                }

                timeouts = retry.timeouts(retryConfig);

                if (!(timeouts.length > attemptNumber)) {
                  _context.next = 10;
                  break;
                }

                timeout = timeouts[attemptNumber];
                return _context.abrupt("return", scheduleRetry(attemptNumber + 1, timeout));

              case 10:
                log('Reached fetch retry limit after %s.', attemptNumber ? "".concat(attemptNumber, " ").concat(attemptNumber === 1 ? 'retry' : 'retries') : 'first attempt');

              case 11:
                if (!err) {
                  _context.next = 13;
                  break;
                }

                throw err;

              case 13:
                return _context.abrupt("return", response);

              case 14:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function considerRetry(_x, _x2, _x3) {
        return _ref2.apply(this, arguments);
      };
    }();

    var scheduleRetry = function scheduleRetry(attemptNumber, timeout) {
      log('Scheduling fetch retry #%s in %sms.', attemptNumber, timeout);
      var retryDelay = resolveAfterTimeout(timeout);
      var timeoutId = retryDelay.timeoutId;

      if (registerTimeout) {
        registerTimeout(timeoutId);
      }

      if (onRetry) {
        onRetry(attemptNumber, timeout);
      }

      return retryDelay.then(function () {
        if (unregisterTimeout) {
          unregisterTimeout(timeoutId);
        }

        return attemptFetch(attemptNumber);
      });
    };

    return attemptFetch(0);
  };
}
/**
 * Create a version of fetch with support for a `prefixUrl` option, so that
 * callers only have to supply a path relative to that prefix. The prefix will
 * automatically have a `/` appended if there is not one already.
 */

export function withPrefixUrl(baseFetch) {
  var defaults = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return function fetch(input) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _options = options,
        _options$prefixUrl = _options.prefixUrl,
        prefixUrl = _options$prefixUrl === void 0 ? defaults.prefixUrl : _options$prefixUrl;

    if (typeof prefixUrl === 'string') {
      if (!endsWithSlash.test(prefixUrl)) {
        prefixUrl += '/';
      }

      input = prefixUrl + input;
      options = _objectSpread(_objectSpread({}, options), {}, {
        prefixUrl: prefixUrl
      });
    }

    return baseFetch(input, options);
  };
}
/**
 * Create a version of `fetch` with a `hooks` API similar to
 * [ky](https://www.npmjs.com/package/ky). Some differences:
 *
 * - `beforeRequest` receives both the `input` and `options` as arguments, and
 *   can optionally return entirely new `fetch` arguments to use instead.
 * - `afterReponse` also receives the `input` and `options` after the
 *   `response` argument, so it can make decisions based on the request that
 *   was sent.
 */

export function withHooks(baseFetch) {
  var defaults = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _defaults$hooks = defaults.hooks,
      defaultHooks = _defaults$hooks === void 0 ? {} : _defaults$hooks;
  return function fetch(input) {
    var _ref3 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var _ref3$hooks = _ref3.hooks,
        hooks = _ref3$hooks === void 0 ? {} : _ref3$hooks,
        options = _objectWithoutProperties(_ref3, ["hooks"]);

    // Merge and clean up.
    hooks = {
      beforeRequest: [].concat(defaultHooks.beforeRequest, hooks.beforeRequest).filter(Boolean),
      afterResponse: [].concat(defaultHooks.afterResponse, hooks.afterResponse).filter(Boolean)
    };
    var fetchArgs = [input, options];
    var _options$log3 = options.log,
        log = _options$log3 === void 0 ? debug : _options$log3;
    hooks.beforeRequest.forEach(function (beforeRequest) {
      var newFetchArgs = beforeRequest.apply(void 0, _toConsumableArray(fetchArgs));

      if (newFetchArgs != null) {
        log('beforeRequest hook returned new fetch params.');
        fetchArgs = newFetchArgs;
      }
    });
    var promise = baseFetch.apply(void 0, _toConsumableArray(fetchArgs));
    hooks.afterResponse.forEach(function (afterResponse) {
      promise = promise.then( /*#__PURE__*/function () {
        var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(response) {
          var newResponse;
          return _regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  _context2.next = 2;
                  return afterResponse.apply(void 0, [response].concat(_toConsumableArray(fetchArgs)));

                case 2:
                  newResponse = _context2.sent;

                  if (!(newResponse != null)) {
                    _context2.next = 6;
                    break;
                  }

                  log('afterResponse hook returned a new response.');
                  return _context2.abrupt("return", newResponse);

                case 6:
                  return _context2.abrupt("return", response);

                case 7:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }));

        return function (_x4) {
          return _ref4.apply(this, arguments);
        };
      }());
    });
    return promise;
  };
}
export function isJsonContentType(response) {
  var contentType = response.headers.get('Content-Type');
  return jsonContentType.test(contentType);
}
/**
 * Create a version of `fetch` with automatic debug logging. By default, a
 * summary line of outgoing requests and incoming responses is sent to this
 * module's `debug` logger. If the `public.debug.verbose` config option is
 * enabled, then additional information like headers and bodies are logged on
 * the server as well.
 */

export function withLogging(baseFetch) {
  // In the browser we have the handy Network tab. On the server we need a way
  // to see more details about the requests going through.
  var verbose = config.has('public.debug.verbose') ? config.get('public.debug.verbose') : false;
  return function fetch(input, options) {
    var _options$log4 = options.log,
        log = _options$log4 === void 0 ? debug : _options$log4;
    log("> %c%s%c %s", 'font-weight: bold', options.method, '', input);

    if (!process.browser && verbose) {
      var headers = options.headers ? toPlainObject(options.headers) : {};

      if (Object.keys(headers).length) {
        log('> Headers:');
        log('%O', headers);
      }

      if (typeof options.body !== 'undefined') {
        log('> Body:');
        log('%O', options.body);
      }
    }

    return baseFetch(input, options).then( /*#__PURE__*/function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(response) {
        var _headers, responseText, clonedResponse, body;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                log("< %c%s%c %s", "font-weight: bold; color: ".concat(response.ok ? 'limegreen' : 'red'), response.status, '', input);

                if (!(!process.browser && verbose)) {
                  _context3.next = 10;
                  break;
                }

                _headers = toPlainObject(response.headers);

                if (Object.keys(_headers).length) {
                  log('< Headers:');
                  log('%O', _headers);
                }

                _context3.next = 6;
                return response.text();

              case 6:
                responseText = _context3.sent;
                clonedResponse = new Response(responseText, {
                  status: response.status,
                  statusText: response.statusText,
                  headers: response.headers
                });

                if (isJsonContentType(response)) {
                  try {
                    body = JSON.parse(responseText);
                    log('< Body:');
                    log('%O', body);
                  } catch (decodeError) {
                    // That's OK, it was just for logging purposes.
                    log('%c!%c %s', 'color: yellow', '', decodeError);
                  }
                } else {
                  log('< Body:');
                  log('%s', responseText);
                }

                return _context3.abrupt("return", clonedResponse);

              case 10:
                return _context3.abrupt("return", response);

              case 11:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      return function (_x5) {
        return _ref5.apply(this, arguments);
      };
    }(), function (err) {
      log('%c!%c %s', 'color: red', '', err);
      throw err;
    });
  };
}
/**
 * Create a version of `fetch` with automatic JSON body serialization and
 * headers.
 */

export function withJson(baseFetch) {
  return function fetch(input) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _options2 = options,
        json = _options2.json;

    if (typeof json !== 'undefined') {
      var body = JSON.stringify(json);
      var headers = new Headers(options.headers);
      headers.set('Content-Type', 'application/json');
      options = _objectSpread(_objectSpread({}, options), {}, {
        body: body,
        headers: headers
      });
    }

    return baseFetch(input, options);
  };
}

function objectToSearchParams(obj) {
  var searchParams = new URLSearchParams();

  var add = function add(name, value) {
    if (typeof value === 'undefined') {
      return;
    }

    if (value == null) {
      value = '';
    }

    searchParams.append(name, value.toString());
  };

  Object.keys(obj).forEach(function (name) {
    var value = obj[name];

    if (Array.isArray(value)) {
      value.forEach(function (item) {
        return add(name, item);
      });
    } else {
      add(name, value);
    }
  });
  return searchParams;
}
/**
 * Create a version of `fetch` with support for a `searchParams` option that
 * updates the `input` URL. It can be a string, a plain object, or a
 * `URLSearchParams` instance.
 */


export function withSearchParams(baseFetch) {
  return function fetch(input) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _options3 = options,
        searchParams = _options3.searchParams;

    if (typeof searchParams === 'string') {
      searchParams = new URLSearchParams(searchParams);
    } else if (Object.prototype.toString.call(searchParams) === '[object Object]') {
      searchParams = objectToSearchParams(searchParams);
    } else if (searchParams == null) {
      searchParams = new URLSearchParams();
    } else {
      searchParams = new URLSearchParams(searchParams.toString());
    }

    var url = new URL(input, getBaseURI());
    var queryString = searchParams.toString();

    if (queryString) {
      url.search = queryString;
    }

    input = url.toString();
    options = _objectSpread(_objectSpread({}, options), {}, {
      searchParams: searchParams
    });
    return baseFetch(input, options);
  };
}
var defaultAgent;
/**
 * Create a shared `https.Agent` instance
 */

function getDefaultAgent() {
  if ( // Technically, this `process.browser` check shouldn't be necessary. We
  // already check it below when setting the `agent` option, and webpack's
  // Terser plugin correctly recognizes that this function is unreachable and
  // entirely removes it. However, webpack has already determined the
  // dependency graph at this point and fails to prune the `https` module and
  // its dependencies. See: https://github.com/webpack/webpack/issues/10281
  !process.browser && !defaultAgent) {
    var customAgentOptions = {}; // If `server.bentoApi.rejectUnauthorized` is false, add
    // `rejectUnauthorized: false` to shared `https.Agent` instance.
    // Useful for API hosts (in QA, for example) that have invalid or self-signed
    // SSL certificates.

    if (config.get('server.bentoApi.rejectUnauthorized') === false) {
      // Require strict `false` value to disable certificate validation.
      customAgentOptions = {
        rejectUnauthorized: false
      };
    }

    if (config.has('server.fetchSettings.agent')) {
      var fetchAgentConfig = config.get('server.fetchSettings.agent');

      if (fetchAgentConfig.keepAlive) {
        customAgentOptions = _objectSpread(_objectSpread({}, customAgentOptions), fetchAgentConfig);
      }
    }

    if (Object.keys(customAgentOptions).length) {
      var https = require('https');

      defaultAgent = new https.Agent(customAgentOptions);
    }
  }

  return defaultAgent;
}
/**
 * Create a version of fetch that has some default options from `defaults`.
 */


export function withDefaults(baseFetch) {
  var defaults = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return function fetch(input) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var correlationId = options.correlationId || defaults.correlationId || generateId('0123456789abcdef', 16);
    var log = options.log || defaults.log;

    if (!log) {
      log = debug.extend(correlationId);
    }

    var method = (options.method || defaults.method || 'GET').toUpperCase();
    var headers = new Headers();

    if (defaults.headers) {
      var defaultHeaders = new Headers(defaults.headers);
      defaultHeaders.forEach(function (value, name) {
        return headers.set(name, value);
      });
    }

    if (options.headers) {
      var moreHeaders = new Headers(options.headers);
      moreHeaders.forEach(function (value, name) {
        return headers.set(name, value);
      });
    }

    var agent = process.browser ? undefined : options.agent || defaults.agent || getDefaultAgent();
    options = _objectSpread(_objectSpread(_objectSpread({
      credentials: 'same-origin'
    }, defaults), options), {}, {
      correlationId: correlationId,
      log: log,
      method: method,
      headers: headers,
      agent: agent
    });
    var promise = baseFetch(input, options);
    return promise;
  };
}
/**
 * Create a custom `fetch` with default options and enhanced features.
 */

export function createFetch() {
  var defaults = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var fetch = global.fetch;
  fetch = withFailureSimulation(fetch);
  fetch = withLogging(fetch);

  if (!process.browser) {
    var _require = require('node-fetch-har'),
        withHar = _require.withHar;

    fetch = withHar(fetch, {
      har: defaults.har
    });
  }

  fetch = withHooks(fetch);
  fetch = withJson(fetch);
  fetch = withTimeout(fetch);
  fetch = withRetry(fetch);
  fetch = withHttpErrors(fetch);
  fetch = withSearchParams(fetch);
  fetch = withPrefixUrl(fetch);
  fetch = withDefaults(fetch, defaults);
  return fetch;
}